import React from 'react';

interface AppointmentValidationProps {
  message: string | undefined;
}

export default function AppointmentValidation({ message }: AppointmentValidationProps) {
  return <div style={{ padding: 20 }}>{message}</div>;
}
